// GarageLeads i18n dictionaries (pt-PT default + en)
export const LANGUAGES = [
  { code: "pt", label: "Português", flag: "PT" },
  { code: "en", label: "English", flag: "EN" },
];

export const translations = {
  pt: {
    brand_tagline: "Leads de Moda & Sportswear",
    made_by: "Criado por Rui Guimarães",
    sidebar_hint_bold: "Com IA",
    sidebar_hint: "prospeção de compradores e equipas de compras.",

    nav_dashboard: "Painel",
    nav_search: "Pesquisa de Leads",
    nav_lists: "Listas",
    nav_settings: "Definições",

    // Common
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    create: "Criar",
    clear: "Limpar",
    close: "Fechar",
    remove: "Remover",
    export_csv: "Exportar CSV",
    search: "Pesquisar",
    loading: "A carregar...",
    add: "Adicionar",

    // Dashboard
    dash_welcome: "Bem-vindo de volta",
    dash_title: "Visão geral da prospeção",
    dash_subtitle: "Inteligência de leads com IA para compradores de moda, vestuário e sportswear.",
    dash_new_search: "Nova pesquisa IA",
    kpi_total: "Total de leads",
    kpi_saved: "Leads guardados",
    kpi_lists: "Listas",
    kpi_pipeline: "Em pipeline",
    quick_search: "Pesquisa rápida IA",
    quick_search_placeholder: "Descreva o seu comprador / contacto de compras ideal...",
    search_leads: "Pesquisar leads",
    outreach_pipeline: "Pipeline de contacto",
    leads_by_subindustry: "Leads por sub-indústria",
    no_data_yet: "Ainda sem dados. Faça uma pesquisa para gerar insights.",
    recent_contacts: "Contactos já pesquisados",
    view_all: "Ver todos",
    recent_empty: "Ainda sem contactos. Faça a sua primeira pesquisa.",

    // Search
    ai_lead_search: "Pesquisa de Leads com IA",
    search_title: "Encontre compradores e contactos de compras",
    search_subtitle: "Descreva o prospeto ideal em linguagem natural. A nossa IA encontra decisores em moda e sportswear.",
    search_placeholder: "ex.: Encontrar gestores de compras em marcas de calçado desportivo de média dimensão na Europa",
    search_tip: "Dica: prima ⌘/Ctrl + Enter para pesquisar",
    searching: "A pesquisar...",
    filters: "Filtros",
    seniority: "Senioridade",
    company_size: "Dimensão da empresa",
    sub_industry: "Sub-indústria",
    locations: "Localizações",
    locations_placeholder: "ex.: Alemanha, EUA",
    titles_keywords: "Cargos / palavras-chave",
    titles_placeholder: "ex.: Comprador, Sourcing",
    num_results: "Número de resultados",
    clear_all_filters: "Limpar todos os filtros",
    start_first_search: "Comece a sua primeira pesquisa IA",
    start_first_search_sub: "Descreva os compradores ou contactos de compras que procura, ou use os filtros, e clique em Pesquisar.",
    no_results_title: "Nenhum lead corresponde à sua pesquisa",
    no_results_sub: "Tente um pedido mais amplo ou remova alguns filtros.",
    found_leads: "Encontrados {n} leads",
    no_leads_generated: "Nenhum lead gerado. Tente ampliar a pesquisa.",
    search_failed: "A pesquisa falhou. Tente novamente.",
    enter_desc_or_filters: "Introduza uma descrição ou escolha alguns filtros",
    selected: "{n} selecionados",
    tag: "Etiqueta",
    add_to_list: "Adicionar à lista",
    new_list_name: "Nome da nova lista",
    saved_n_leads: "Guardados {n} leads",
    tagged_n_leads: "Etiquetados {n} leads",
    csv_exported: "CSV exportado",
    added_to: "Adicionado a {name}",

    // Saved searches
    saved_searches: "Pesquisas guardadas",
    save_search: "Guardar pesquisa",
    save_search_title: "Guardar esta pesquisa",
    search_name: "Nome da pesquisa",
    search_name_placeholder: "ex.: Compradores de calçado UE",
    no_saved_searches: "Ainda sem pesquisas guardadas.",
    search_saved: "Pesquisa guardada",
    search_deleted: "Pesquisa eliminada",
    load: "Carregar",

    // History / duplicates
    tab_results: "Resultados",
    tab_history: "Histórico",
    already_searched: "Já pesquisados",
    already_seen: "Já visto",
    history_empty: "Ainda não pesquisou contactos. Faça a sua primeira pesquisa acima.",
    history_hint: "Contactos já pesquisados anteriormente — sem precisar de pesquisar de novo.",
    dup_in_results: "{n} já existiam (a cinzento)",

    // Lead detail
    contact: "Contacto",
    location: "Localização",
    tags: "Etiquetas",
    no_tags: "Ainda sem etiquetas",
    add_tag: "Adicionar etiqueta",
    outreach_status: "Estado de contacto",
    select_list: "Selecione uma lista",
    no_lists_yet: "Ainda sem listas",
    email_copied: "Email copiado",
    phone_copied: "Telefone copiado",
    update_failed: "Falha ao atualizar",

    // Table headers
    th_name: "Nome",
    th_title: "Cargo",
    th_company: "Empresa",
    th_location: "Localização",
    th_subindustry: "Sub-indústria",
    th_status: "Estado",
    th_email: "Email",
    th_actions: "Ações",

    // Lists
    lists_title: "Listas",
    lists_subtitle: "Organize leads guardados e acompanhe o estado de contacto.",
    new_list: "Nova lista",
    create_new_list: "Criar uma nova lista",
    list_name: "Nome",
    list_name_placeholder: "ex.: Compradores de Calçado UE",
    description_optional: "Descrição (opcional)",
    description_placeholder: "Breve descrição",
    create_list: "Criar lista",
    create_first_list: "Crie a sua primeira lista",
    create_first_list_sub: "Guarde leads da página de pesquisa em listas para gerir o contacto.",
    leads_count: "leads",
    delete_list_q: "Eliminar esta lista?",
    delete_list_desc: "Isto remove a lista \"{name}\". Os leads permanecem na base de dados.",
    remove_from_list: "Remover da lista",
    no_leads_in_list: "Sem leads nesta lista",
    no_leads_status: "Sem leads com estado \"{status}\"",
    add_leads_from_search: "Adicione leads a partir da página de Pesquisa.",
    list_created: "Lista \"{name}\" criada",
    list_deleted: "Lista eliminada",
    removed_n_leads: "Removidos {n} leads",
    exporting_csv: "A exportar CSV...",
    all: "Todos",

    // Settings
    settings_title: "Definições",
    settings_subtitle: "Configure o modelo de IA usado para gerar leads.",
    llm_config: "Configuração do modelo de IA (LLM)",
    llm_config_desc: "Por predefinição a app usa a chave integrada. Pode ligar a sua própria chave de API de OpenAI, Anthropic ou Gemini.",
    use_builtin: "Usar chave integrada (predefinição)",
    use_builtin_desc: "Pronto a usar, sem configuração. Ideal para começar já.",
    use_own: "Usar a minha própria chave de API",
    use_own_desc: "Ligue a sua conta de OpenAI, Anthropic ou Google Gemini.",
    provider: "Fornecedor",
    model: "Modelo",
    api_key: "Chave de API",
    api_key_placeholder: "Cole a sua chave de API",
    api_key_stored: "Chave guardada (deixe em branco para manter)",
    test_connection: "Testar ligação",
    testing: "A testar...",
    save_settings: "Guardar definições",
    settings_saved: "Definições guardadas",
    connection_ok: "Ligação bem-sucedida!",
    connection_failed: "Ligação falhou",
    active_source_builtin: "A usar a chave integrada",
    active_source_own: "A usar a sua chave própria",
    key_required: "A chave de API é obrigatória",
    where_get_key: "Onde obter uma chave?",
  },

  en: {
    brand_tagline: "Fashion & Sportswear Leads",
    made_by: "Created by Rui Guimarães",
    sidebar_hint_bold: "AI-powered",
    sidebar_hint: "prospecting for buyers & procurement teams.",

    nav_dashboard: "Dashboard",
    nav_search: "Lead Search",
    nav_lists: "Lists",
    nav_settings: "Settings",

    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    create: "Create",
    clear: "Clear",
    close: "Close",
    remove: "Remove",
    export_csv: "Export CSV",
    search: "Search",
    loading: "Loading...",
    add: "Add",

    dash_welcome: "Welcome back",
    dash_title: "Your prospecting overview",
    dash_subtitle: "AI-powered lead intelligence for fashion, apparel & sportswear buyers.",
    dash_new_search: "New AI Search",
    kpi_total: "Total leads",
    kpi_saved: "Saved leads",
    kpi_lists: "Lists",
    kpi_pipeline: "In pipeline",
    quick_search: "Quick AI search",
    quick_search_placeholder: "Describe your ideal buyer / procurement contact...",
    search_leads: "Search leads",
    outreach_pipeline: "Outreach pipeline",
    leads_by_subindustry: "Leads by sub-industry",
    no_data_yet: "No data yet. Run a search to populate insights.",
    recent_contacts: "Already searched contacts",
    view_all: "View all",
    recent_empty: "No contacts yet. Run your first search.",

    ai_lead_search: "AI Lead Search",
    search_title: "Find buyers & procurement contacts",
    search_subtitle: "Describe your ideal prospect in plain English. Our AI finds matching decision-makers in fashion & sportswear.",
    search_placeholder: "e.g. Find procurement managers at mid-size athletic footwear brands in Europe",
    search_tip: "Tip: press ⌘/Ctrl + Enter to search",
    searching: "Searching...",
    filters: "Filters",
    seniority: "Seniority",
    company_size: "Company size",
    sub_industry: "Sub-industry",
    locations: "Locations",
    locations_placeholder: "e.g. Germany, USA",
    titles_keywords: "Job titles / keywords",
    titles_placeholder: "e.g. Buyer, Sourcing",
    num_results: "Number of results",
    clear_all_filters: "Clear all filters",
    start_first_search: "Start your first AI search",
    start_first_search_sub: "Describe the buyers or procurement contacts you're looking for, or use the filters, then hit Search.",
    no_results_title: "No leads match your search",
    no_results_sub: "Try a broader AI prompt or remove some filters.",
    found_leads: "Found {n} leads",
    no_leads_generated: "No leads generated. Try broadening your search.",
    search_failed: "Search failed. Please retry.",
    enter_desc_or_filters: "Enter a description or pick some filters",
    selected: "{n} selected",
    tag: "Tag",
    add_to_list: "Add to list",
    new_list_name: "New list name",
    saved_n_leads: "Saved {n} leads",
    tagged_n_leads: "Tagged {n} leads",
    csv_exported: "CSV exported",
    added_to: "Added to {name}",

    saved_searches: "Saved searches",
    save_search: "Save search",
    save_search_title: "Save this search",
    search_name: "Search name",
    search_name_placeholder: "e.g. EU Footwear Buyers",
    no_saved_searches: "No saved searches yet.",
    search_saved: "Search saved",
    search_deleted: "Search deleted",
    load: "Load",

    // History / duplicates
    tab_results: "Results",
    tab_history: "History",
    already_searched: "Already searched",
    already_seen: "Already seen",
    history_empty: "You haven't searched any contacts yet. Run your first search above.",
    history_hint: "Contacts you've searched before — no need to search again.",
    dup_in_results: "{n} already existed (greyed out)",

    contact: "Contact",
    location: "Location",
    tags: "Tags",
    no_tags: "No tags yet",
    add_tag: "Add tag",
    outreach_status: "Outreach status",
    select_list: "Select a list",
    no_lists_yet: "No lists yet",
    email_copied: "Email copied",
    phone_copied: "Phone copied",
    update_failed: "Update failed",

    th_name: "Name",
    th_title: "Title",
    th_company: "Company",
    th_location: "Location",
    th_subindustry: "Sub-industry",
    th_status: "Status",
    th_email: "Email",
    th_actions: "Actions",

    lists_title: "Lists",
    lists_subtitle: "Organize saved leads and track outreach status.",
    new_list: "New list",
    create_new_list: "Create a new list",
    list_name: "Name",
    list_name_placeholder: "e.g. EU Footwear Buyers",
    description_optional: "Description (optional)",
    description_placeholder: "Short description",
    create_list: "Create list",
    create_first_list: "Create your first list",
    create_first_list_sub: "Save leads from the search page into lists to manage outreach.",
    leads_count: "leads",
    delete_list_q: "Delete this list?",
    delete_list_desc: "This removes the list \"{name}\". Leads remain in your database.",
    remove_from_list: "Remove from list",
    no_leads_in_list: "No leads in this list",
    no_leads_status: "No leads with status \"{status}\"",
    add_leads_from_search: "Add leads from the Search page.",
    list_created: "List \"{name}\" created",
    list_deleted: "List deleted",
    removed_n_leads: "Removed {n} leads",
    exporting_csv: "Exporting CSV...",
    all: "All",

    settings_title: "Settings",
    settings_subtitle: "Configure the AI model used to generate leads.",
    llm_config: "AI model (LLM) configuration",
    llm_config_desc: "By default the app uses the built-in key. You can connect your own OpenAI, Anthropic or Gemini API key.",
    use_builtin: "Use built-in key (default)",
    use_builtin_desc: "Ready to use, no setup. Great to get started right away.",
    use_own: "Use my own API key",
    use_own_desc: "Connect your OpenAI, Anthropic or Google Gemini account.",
    provider: "Provider",
    model: "Model",
    api_key: "API key",
    api_key_placeholder: "Paste your API key",
    api_key_stored: "Key stored (leave blank to keep)",
    test_connection: "Test connection",
    testing: "Testing...",
    save_settings: "Save settings",
    settings_saved: "Settings saved",
    connection_ok: "Connection successful!",
    connection_failed: "Connection failed",
    active_source_builtin: "Using the built-in key",
    active_source_own: "Using your own key",
    key_required: "API key is required",
    where_get_key: "Where to get a key?",
  },
};
